import { P, Stack, useText } from "@sveabank/cc-common";

const NoBeneficialOwner = () => {
	const [t, texts] = useText();
	return (
		<Stack gap={4}>
			<Stack>
				<P bold>{t(texts.kyc.beneficialOwnership.noBoTitle)}</P>
				<P>{t(texts.kyc.beneficialOwnership.noBoDescription)}</P>
			</Stack>
		</Stack>
	);
};

export default NoBeneficialOwner;
